import AnniversaryIcon from '@assets/icons/AnniversaryIcon'
import CardIcon from '@assets/icons/CardIcon'
import { colors } from '@globals/themes/defaultTheme'
import { CelebrationType, CelebrationTypeEnum } from '@kudos/http-client'
import CakeOutlined from '@mui/icons-material/CakeOutlined'
import MilitaryTechOutlinedIcon from '@mui/icons-material/MilitaryTechOutlined'
import WavingHandOutlined from '@mui/icons-material/WavingHandOutlined'
import { ReactElement } from 'react'

export const celebrationIcon: Record<CelebrationType, ReactElement> = {
  [CelebrationTypeEnum.ANNIVERSARY]: <MilitaryTechOutlinedIcon />,
  [CelebrationTypeEnum.ONBOARDING]: <AnniversaryIcon fill={colors.aquaPrimary} />,
  [CelebrationTypeEnum.BIRTHDAY]: <CakeOutlined />,
  [CelebrationTypeEnum.WELCOME]: <WavingHandOutlined />,
  [CelebrationTypeEnum.OTHER]: <CardIcon />,
}

export const celebrationIconColor: Record<CelebrationType, string> = {
  [CelebrationTypeEnum.ANNIVERSARY]: colors.irisPrimary,
  [CelebrationTypeEnum.ONBOARDING]: colors.aquaPrimary,
  [CelebrationTypeEnum.BIRTHDAY]: colors.goldPrimary,
  [CelebrationTypeEnum.WELCOME]: colors.blueMedium,
  [CelebrationTypeEnum.OTHER]: colors.orchidPrimary,
}

export const celebrationIconBgColor: Record<CelebrationType, string> = {
  [CelebrationTypeEnum.ANNIVERSARY]: colors.irisExtraLight,
  [CelebrationTypeEnum.ONBOARDING]: colors.aquaExtraLight,
  [CelebrationTypeEnum.BIRTHDAY]: colors.goldExtraLight,
  [CelebrationTypeEnum.WELCOME]: colors.blueExtraLight,
  [CelebrationTypeEnum.OTHER]: colors.orchidExtraLight,
}

export const celebrationBgColor: Record<CelebrationType, string | undefined> = {
  [CelebrationTypeEnum.ANNIVERSARY]: colors.irisUltraLight,
  [CelebrationTypeEnum.ONBOARDING]: colors.aquaUltraLight,
  [CelebrationTypeEnum.BIRTHDAY]: colors.goldUltraLight,
  [CelebrationTypeEnum.WELCOME]: colors.blueUltraLight,
  [CelebrationTypeEnum.OTHER]: undefined,
}
